// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3v54g","select":"Header_select__2Kdb_","clinic":"Header_clinic__3Bfuh"};